/**
 * Session remark feature — kept for future product use.
 * When false: Remark column, add/edit buttons, and remark modal are not shown.
 * Backend API (`PATCH /attendance/:id/session-remark`) and SessionRemarkModal remain intact.
 */
export const SHOW_SESSION_REMARK_UI = false;
